import React from 'react';

import type { Nullable, SimpleAnyObject, SimpleObject } from '@clearverify/types';

import { SignupVerifierFormStepId } from 'src/constants/auth';

export type FormStepperVerifierState = {
  previousStepId?: string | null;
  currentStepId: string;
  nextStepId?: string | null;
  isNextStepAvailable: boolean;
  isLastStep: boolean;
};

export type AuthSignupVerifierContextValue = {
  formData: SimpleObject;
  formRelatedPage: SimpleAnyObject;
  setFormData: (formValues: SimpleObject) => void;
  updateFormData: (formValues: SimpleObject) => void;
  updateFormRelatedPage: (formValues: Nullable<SimpleObject>) => void;
  formStepperState: FormStepperVerifierState;
  goToNextStep: () => void;
  goToStep: (stepId: SignupVerifierFormStepId) => void;
  goToPreviousStep: () => void;
  setCurrentStepIndex: React.Dispatch<React.SetStateAction<number>>;
  setFormFlow: React.Dispatch<React.SetStateAction<SignupVerifierFormStepId[]>>;
};

export const AuthSignupVerifierContext = React.createContext({} as AuthSignupVerifierContextValue);
